import { useEffect, useState } from "react";
import { publicApi } from "@/lib/api";
import { useInquiryDialog } from "@/context/InquiryDialogContext";
import HeroSection from "@/components/home/HeroSection";
import CorporateIntroSection from "@/components/home/CorporateIntroSection";
import ShowcaseSection from "@/components/home/ShowcaseSection";
import CategoryShowcaseSection from "@/components/home/CategoryShowcaseSection";
import FeaturedListingsSection from "@/components/home/FeaturedListingsSection";
import TeamSection from "@/components/home/TeamSection";
import InquiryCtaSection from "@/components/home/InquiryCtaSection";

const HomePage = () => {
  const { openDialog } = useInquiryDialog();
  const [listings, setListings] = useState([]);
  const [team, setTeam] = useState([]);
  const [showcaseItems, setShowcaseItems] = useState([]);
  const [loadingListings, setLoadingListings] = useState(true);
  const [loadingTeam, setLoadingTeam] = useState(true);
  const [loadingShowcase, setLoadingShowcase] = useState(true);

  useEffect(() => {
    publicApi
      .get("/listings")
      .then((res) => setListings(res.data.slice(0, 4)))
      .catch(() => {})
      .finally(() => setLoadingListings(false));
    publicApi
      .get("/team")
      .then((res) => setTeam(res.data))
      .catch(() => {})
      .finally(() => setLoadingTeam(false));
    publicApi
      .get("/showcase")
      .then((res) => setShowcaseItems(res.data))
      .catch(() => {})
      .finally(() => setLoadingShowcase(false));
  }, []);

  return (
    <div>
      <HeroSection onOpenInquiry={() => openDialog()} />
      <CorporateIntroSection />
      <ShowcaseSection items={showcaseItems} loading={loadingShowcase} />
      <CategoryShowcaseSection />
      <FeaturedListingsSection listings={listings} loading={loadingListings} />
      <TeamSection team={team} loading={loadingTeam} />
      <InquiryCtaSection onOpenInquiry={() => openDialog()} />
    </div>
  );
};

export default HomePage;
